import script from "./LogoAnimation.vue?vue&type=script&setup=true&lang=ts"
export * from "./LogoAnimation.vue?vue&type=script&setup=true&lang=ts"

import "./LogoAnimation.vue?vue&type=style&index=0&id=67bd7649&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67bd7649"]])

export default __exports__